<template>

<div>



  <v-card flat v-show="!this.$store.state.H5P.isVideoReady && this.$store.state.currentEditTab == 'presenter_tab'">



    <v-progress-linear
      indeterminate
      color="green"
    ></v-progress-linear>

    <v-card-text> Initializing Shuttle... </v-card-text>

</v-card>


<v-card flat v-show="this.$store.state.H5P.isVideoReady && this.$store.state.currentEditTab == 'presenter_tab'">

  <v-toolbar flat>
          <v-toolbar-title>Current Speakers</v-toolbar-title>




          <v-spacer></v-spacer>

      <!-- @click="newBookmark()" -->
      <v-btn width="100" outlined small color="primary" @click="displayForm()">
       + Add
      </v-btn>

      </v-toolbar>
      <v-card class="mr-3 ml-3" v-show="display_form">
        <v-card-subtitle class="font-weight-bold">ADD NEW SPEAKER</v-card-subtitle>
        <v-card-text>


          <v-text-field
          v-model="currentSpk.display_name"
          label="Display Name"
          placeholder="Enter full display name: i.e Dr. John Doe, Phd."
          required
          outlined
           dense

          ></v-text-field>
          <v-text-field
          v-model="currentSpk.email"
          label="Email"
          placeholder="Email for this speaker"
          required
          outlined
           dense

          ></v-text-field>

          <v-text-field
          v-model="currentSpk.external_id"
          label="External Id"
          placeholder="Unique ID for this speaker from your AMS or CRM."
          required
          outlined
           dense

          ></v-text-field>

         <v-container v-show="show_picture_upload" class="mx-0 px-0 pt-0 mt-0 pb-6">
            <div  id="speaker_upload" class="dropzone" ref="speaker_upload"></div>

           </v-container>

           <v-container  v-show="show_picture">
                  {{currentSpk.img}}
                  <img :src="currentSpk.img_url" style="width:64px; border-radius: 25%;"/>
                   <v-icon
                  small
                  class="mr-2"
                  @click="deletePicture(currentSpk)"
                >
                  mdi-delete-forever-outline
                </v-icon>



          </v-container>


          <v-textarea
          v-model="currentSpk.description"
            outlined
            name="spk_description"
            label="Speaker Description"
            rows=1
            :value="currentSpk.description"
             dense

          ></v-textarea>

          <v-textarea
          v-model="currentSpk.disclosure"
            outlined
            name="spk_disclosure"
            label="Speaker Disclosure"
              rows=1
            :value="currentSpk.disclosure"
             dense
          ></v-textarea>



          <v-select
          v-model="selected_transcript_speakers"
          :items="transcript_speakers"
          chips
          multiple
          label="Transcript Mappings"
          return-object

          item-text="id"
          item-value="id"
          dense
          >

          </v-select>


        </v-card-text>

        <div class="text-right">
          <v-btn width="100" small outlined text color="primary" class="mx-4 mb-4" @click="closeFormDisplay()">
            Cancel
          </v-btn>
          <v-btn width="100" small color="primary" class="mx-4 mb-4" @click="saveSpeaker()" :loading="saving">
            Save
          </v-btn>
        </div>

      </v-card>
        <v-container class="ma-0 pa-0" fluid>

            <v-row no-gutters>

              <v-col cols="12" md="12" sm="12">



                                      <v-data-iterator
                                      class="pa-3"
                                        :items="speakerList"
                                        hide-default-footer

                                        no-data-text="Click the '+ ADD' button above to add your first presenter (speaker)."
                                      >

                                    <template v-slot:header>
                                    </template>

                                    <template v-slot:default="props">
                                      <v-container>
                                        <v-row>
                                            <v-col
                                              v-for="(item, presenter_idx) in props.items"
                                              :key="presenter_idx"
                                              cols="12"
                                              sm="12"
                                              md="12"
                                              class="pt-0"
                                            >

                                              <v-card v-show="editing_item !== presenter_idx">

                                                <v-row>
                                                  <v-col md="2">
                                                  <v-img contain width="80" height="80" class="ml-2"
                                                    :src="$store.state.uri.app_base_uri + '/uploads/' + $store.state.currentShuttle.customer_id + '/shuttles/' + $store.state.currentShuttle.id + '/images/' + item.img"
                                                  ></v-img>
                                                </v-col>
                                                  <v-col cols="8" class="text-left">
                                                    <div class="subheading font-weight-bold">{{ item.display_name }}</div>
                                                    <div>{{ item.time }}</div>
                                                  </v-col>

                                                  <v-col cols="2">
                                                    <v-btn icon   @click="editItem(item, presenter_idx)">
                                                      <v-icon


                                                      >
                                                        mdi-pencil
                                                      </v-icon>
                                                    </v-btn>


                                                    <v-btn icon @click="deleteItem(item)">
                                                      <v-icon



                                                      >
                                                        mdi-delete-forever-outline
                                                      </v-icon>
                                                    </v-btn>
                                                  </v-col>
                                                </v-row>

                                              </v-card>



                                              <v-card v-show="presenter_idx === editing_item">
                                                <v-card-subtitle class="font-weight-bold">EDIT SPEAKER INFO</v-card-subtitle>
                                                <v-card-text>

                                                  <v-text-field
                                                  v-model="currentSpk.display_name"
                                                  label="Display Name"
                                                  placeholder="Enter full display name: i.e Dr. John Doe, Phd."
                                                  required
                                                  outlined
                                                  dense

                                                  ></v-text-field>

                                                  <v-text-field
                                                  v-model="currentSpk.email"
                                                  label="Email"
                                                  placeholder="Email for this speaker"
                                                  required
                                                  outlined
                                                   dense

                                                  ></v-text-field>

                                                  <v-text-field
                                                  v-model="currentSpk.external_id"
                                                  label="External Id"
                                                  placeholder="Unique ID for this speaker from your AMS or CRM."
                                                  required
                                                  outlined
                                                   dense

                                                  ></v-text-field>

                                                 <v-container v-show="show_picture_upload" class="mx-0 px-0 pt-0 mt-0 pb-6">
                                                  <div  :id="'edit_speaker_upload'+presenter_idx" class="dropzone" :ref="'edit_speaker_upload'+presenter_idx"></div>

                                                   </v-container>

                                                   <v-container  v-show="show_picture">
                                                          {{currentSpk.img}}
                                                          <img :src="currentSpk.img_url" style="width:64px; border-radius: 25%;"/>
                                                           <v-icon
                                                          small
                                                          class="mr-2"
                                                          @click="deleteEditPicture(currentSpk)"
                                                        >
                                                          mdi-delete-forever-outline
                                                        </v-icon>


                                                  </v-container>


                                                  <v-textarea
                                                  v-model="currentSpk.description"
                                                    outlined
                                                    name="spk_description"
                                                    label="Speaker Description"
                                                    rows=1
                                                    :value="currentSpk.description"
                                                     dense

                                                  ></v-textarea>

                                                  <v-textarea
                                                  v-model="currentSpk.disclosure"
                                                    outlined
                                                    name="spk_disclosure"
                                                    label="Speaker Disclosure"
                                                      rows=1
                                                    :value="currentSpk.disclosure"
                                                     dense
                                                  ></v-textarea>



                                                  <v-select
                                                  v-model="selected_transcript_speakers"
                                                  :items="transcript_speakers"
                                                  chips
                                                  multiple
                                                  label="Transcript Mappings"
                                                  return-object

                                                  item-text="id"
                                                  item-value="id"
                                                  dense
                                                  >

                                                  </v-select>


                                                </v-card-text>

                                                <div class="text-right">
                                                  <v-btn width="100" small outlined text color="primary" class="mx-4 mb-4" @click="closeEditFormDisplay()">
                                                    Cancel
                                                  </v-btn>
                                                  <v-btn width="100" small color="primary" class="mx-4 mb-4" @click="saveSpeaker()" :loading="saving">
                                                    Save
                                                  </v-btn>
                                                </div>

                                              </v-card>






                                            </v-col>
                                        </v-row>
                                      </v-container>
                                    </template>






                                      </v-data-iterator>

              </v-col>






            </v-row>


        </v-container>




</v-card>
</div>

</template>





<!--

//-->


<script>

import ShuttleMixins from '@/mixins/ShuttleMixins.js';
import { v4 as uuidv4 } from 'uuid';
import { mapState } from 'vuex';
import Dropzone from 'dropzone'
Dropzone.autoDiscover = false

export default {
  name: 'ShuttlePresenters',
  mixins:[ShuttleMixins],
  data() {
    return {
      saving:false,
        display_form: false,

        currentSpk:{
            id:'',
            display_name:'',
            email:'',
            external_id:'',
            disclosure:'Nothing to Disclose',
            description:'',
            img:'',
            img_url:''

        },

        add_presenter:true,
        show_picture_upload:true,
        show_picture:false,

        transcript_speakers:[],




         nameRules: [
                v => !!v || 'Display Name is required'
              ],



         speakerList:[],
             headers: [

          { text: 'Speaker', value: 'display_name' },
          { text: 'Actions', value: 'actions', sortable: false }
        ],

        selected_transcript_speakers:[],

        init_dropzone:true,
        edit_init_dropzone:true,

        editing_item: -1,
        dropzone: null,
        dropzone_editor: null,

    }

  },
  mounted() {
    
        this.init();




    },

 props:{

    tabupdate:Number
},

watch:{

    tabupdate(){

       // //console.log('Transcript Tab update')

        //if (this.tabupdate === 1) { this.init(); }
        this.init();
    },

    selected_transcript_speakers(){

        var newmap = [];
        ////console.log(this.selected_transcript_speakers);

        if(this.currentSpk.transcript_map){
                delete this.currentSpk.transcript_map;

        }


        if(this.selected_transcript_speakers.length > 0){
            this.currentSpk.transcript_map = this.selected_transcript_speakers;
        }

    }
},



   created(){

      var vm = this;
      this.unsubscribe = this.$store.subscribe((mutation, state) => {


               if (mutation.type  === 'currentShuttle'){
                vm.init();
              }


          });

 },
  beforeDestroy() {
    this.unsubscribe();
  },

  methods: {


        init(){
            //this.$store.commit('help', 'presenter_info');
        //get any current speakers
        if(this.$store.state.currentShuttle.speakers){
                this.speakerList = this.$store.state.currentShuttle.speakers;
        } else {

            this.speakerList = [];
        }

        this.getTranscriptSpeakers();
        this.currentSpk.id = uuidv4();
        this.initDropZone();
        var vm = this;


        },

        deletePicture(){
            this.currentSpk.img = '';
            this.currentSpk.img_url = '';
            this.show_picture = false;
          this.show_picture_upload = true;
          this.dropzone.removeAllFiles( true );

        },

        deleteEditPicture(){
            this.currentSpk.img = '';
            this.currentSpk.img_url = '';
            this.show_picture = false;
          this.show_picture_upload = true;
          this.dropzone_editor.removeAllFiles( true );

        },



        displayForm() {
          this.display_form = true;
          //this.init_dropzone = true;
          this.newSpeaker();


        },

        closeFormDisplay() {
          this.display_form = false;
          this.newSpeaker();
        },

        closeEditFormDisplay() {
          this.editing_item = -1;
          this.newSpeaker();
        },


        newSpeaker(){

               this.editing_item = -1;
               this.selected_transcript_speakers = [];
               this.currentSpk = {
                            id:'',
                            display_name:'',
                            email:'',
                            external_id:'',
                            disclosure:'Nothing to Disclose',
                            description:'',
                            img:'',
                            img_url:'',
                            start_time:0,
                            transcript_map:[]

                        }
                 this.currentSpk.id = uuidv4();
                 this.dropzone.removeAllFiles( true );
                 this.show_picture_upload = true;

        },

        editItem(item, selected_idx){

          this.display_form = false;

          this.editing_item = selected_idx;

            this.currentSpk = item;

            if(this.currentSpk.img){


                    if(this.currentSpk.img == ""){
                        this.show_picture_upload = true;
                        this.show_picture = false;

                        this.initDropZone();
                    } else {

                        this.show_picture_upload = false;
                        this.show_picture = true;
                        this.initEditDropZone();


                    }
            } else {

              this.show_picture = false;
              this.show_picture_upload = true;
                this.initEditDropZone();


          }


            if(this.currentSpk.transcript_map){
                    if(this.currentSpk.transcript_map.length > 0){
                        this.selected_transcript_speakers = this.currentSpk.transcript_map;

                    }

            }

          //  this.edit_init_dropzone = false;
        },

    deleteItem(item){
          this.speakerList = this.speakerList.filter(speakers => speakers.id != item.id);
          this.dropzone.removeAllFiles( true );
         this.saveSpeakers();
          this.generateDynamicH5p();

      },


    async  getTranscriptSpeakers(){


        //to avoid Cloudfront Cashinge, we can save a version of each transcript update. Check to see if it exists, if not set to a new url.
        //The responce to the update should return the new version to be loaded.

        var path;

         if(this.$store.state.currentShuttle.transcriptPath){


            path  = this.$store.state.currentShuttle.transcriptPath;

            let transcriptresponse = await this.getData(path,'get',null,this.$store.state.uri.app_base_uri);
            var speakerGroups = [];

            if(transcriptresponse.results.hasOwnProperty("speaker_labels")){
              speakerGroups = Object.assign([],transcriptresponse.results.speaker_labels.segments);
           }

           ////console.log(transcriptresponse.results);

           ////console.log(speakerGroups);


            var existingSpeaker;

            for (var speaker of speakerGroups){
              ////console.log("SPEAKER", speaker);

                 var spk = {};
                existingSpeaker = this.transcript_speakers.find(({id}) => id == speaker.speaker_label);
                ////console.log(existingSpeaker);
                if(existingSpeaker == undefined){
                    spk.id = speaker.speaker_label;
                    spk.start_time = speaker.start_time;
                    this.transcript_speakers.push(spk);

                }
            }




         }


        ////console.log(this.transcript_speakers)







      },


        saveSpeakers(){

                          this.$store.commit('currentShuttleSpeakers',this.speakerList);


                this.saveShuttle();


        },

        saveSpeaker(){

          this.saving = true;
                ////console.log('TRANSCRIPT MAP??')
                ////console.log(this.selected_transcript_speakers);

                if(this.selected_transcript_speakers.length > 0){

                    this.currentSpk.transcript_map = this.selected_transcript_speakers;
                    this.currentSpk.start_time = this.selected_transcript_speakers[0].start_time;
                }

                if(this.$store.state.currentShuttle.speakers){
                    let currentPresenter = this.$store.state.currentShuttle.speakers.find(({id}) => id == this.currentSpk.id);

                        if(currentPresenter){

                            currentPresenter = this.currentSpk;
                        } else {

                            this.speakerList.push(this.currentSpk);

                        }
                } else {

                    this.speakerList.push(this.currentSpk);
                }

                ////console.log(this.currentSpk);


                for(var speaker of this.speakerList){

                    speaker = this.cleanObjectDynamo(speaker);

                }

            ////console.log(this.speakerList);
            this.saveSpeakers();
            this.saving = false;
            this.display_form = false;
            this.editing_item = -1;




        },




      getSignedURL (file) {


          var keypath = 'uploads/' + this.$store.state.currentShuttle.customer_id + '/shuttles/' + this.$store.state.currentShuttle.id + '/images/'
          let endpoint = this.$store.state.uri.signed_uri
          let payload = {
            filePath: keypath + file.name,
            contentType: file.type
          }
          return this.$axios.post(endpoint, payload)
            .then((res) => {
              return Promise.resolve(res.data.url || '/')
            })
            .catch((err) => {
              console.error(err)
              return Promise.reject('/')
            })
  },



  saveUpload(file){

        this.currentSpk.img = file.name;
        this.currentSpk.img_url =  this.$store.state.uri.app_base_uri + '/uploads/' + this.$store.state.currentShuttle.customer_id + '/shuttles/' + this.$store.state.currentShuttle.id + '/images/' + file.name;
        this.show_picture_upload = false;
        this.show_picture = true;

  },



      initDropZone(){

        if(this.init_dropzone){
         // //console.log("IN INIT");

      const vm = this;
    let options = {
      // The URL will be changed for each new file being processing
      url: '/',

      // Since we're going to do a `PUT` upload to S3 directly
      method: 'put',

      // Hijack the xhr.send since Dropzone always upload file by using formData
      // ref: https://github.com/danialfarid/ng-file-upload/issues/743
      sending (file, xhr) {
        let _send = xhr.send
        //console.log(xhr)
        xhr.send = () => {
          _send.call(xhr, file)
        }
      },

      // Upload one file at a time since we're using the S3 pre-signed URL scenario
      parallelUploads: 1,
      uploadMultiple: false,
            timeout:3600000,
      maxFilesize: 750,

      // Content-Type should be included, otherwise you'll get a signature
      // mismatch error from S3. We're going to update this for each file.
      header: '',

      // Customize the wording
     // dictDefaultMessage: document.querySelector('#dropzone-message').innerHTML,

     dictDefaultMessage: 'Drag and Drop your Speaker Picture here (.jpg,.png). Or click to select.',

      // We're going to process each file manually (see `accept` below)
      autoProcessQueue: false,

      // Here we request a signed upload URL when a file being accepted
      accept (file, done) {
        vm.getSignedURL(file)
          .then((url) => {
            file.uploadURL = url
            //console.log(file.uploadURL)
            done()
            // Manually process each file
            setTimeout(() => vm.dropzone.processFile(file))
          })
          .catch((err) => {
            done('Failed to get an S3 signed upload URL', err)
          })
      }
    }


    // Instantiate Dropzone
    //console.log("INIT DROP UPLOAD")
    //console.log(this.$refs["speaker_upload"]);
    this.dropzone = new Dropzone(this.$refs["speaker_upload"], options)

    // Set signed upload URL for each file
    // Set signed upload URL for each file
    vm.dropzone.on('processing', (file) => {
      vm.dropzone.options.url = file.uploadURL
    })


    vm.dropzone.on('success', (file) => {
      //vm.dropzone.options.url = file.uploadURL

      ////console.log(file);

     //var vidObj = {video:file.name,video_status:'UPLOADED'};
     // vm.$store.commit('currentShuttleVideo', vidObj);



      vm.saveUpload(file);

    })

  this.init_dropzone = false;

} else {
//console.log("NOT IN INIT");
}

      },




      initEditDropZone() {

          if(this.edit_init_dropzone){
            //console.log("INedit INIT");

        const vm = this;
      let options = {
        // The URL will be changed for each new file being processing
        url: '/',

        // Since we're going to do a `PUT` upload to S3 directly
        method: 'put',

        // Hijack the xhr.send since Dropzone always upload file by using formData
        // ref: https://github.com/danialfarid/ng-file-upload/issues/743
        sending (file, xhr) {
          let _send = xhr.send
          //console.log(xhr)
          xhr.send = () => {
            _send.call(xhr, file)
          }
        },

        // Upload one file at a time since we're using the S3 pre-signed URL scenario
        parallelUploads: 1,
        uploadMultiple: false,
              timeout:3600000,
        maxFilesize: 750,

        // Content-Type should be included, otherwise you'll get a signature
        // mismatch error from S3. We're going to update this for each file.
        header: '',

        // Customize the wording
       // dictDefaultMessage: document.querySelector('#dropzone-message').innerHTML,

       dictDefaultMessage: 'Drag and Drop your Speaker Picture here (.jpg,.png). Or click to select.',

        // We're going to process each file manually (see `accept` below)
        autoProcessQueue: false,

        // Here we request a signed upload URL when a file being accepted
        accept (file, done) {
          vm.getSignedURL(file)
            .then((url) => {
              file.uploadURL = url
              //console.log(file.uploadURL)
              done()
              // Manually process each file
              setTimeout(() => vm.dropzone_editor.processFile(file))
            })
            .catch((err) => {
              done('Failed to get an S3 signed upload URL', err)
            })
        }
      }


      // Instantiate Dropzone
      //console.log("INIT UPLOAD")
      //console.log(this.$refs["edit_speaker_upload"+this.editing_item][0]);
      this.dropzone_editor = new Dropzone(this.$refs["edit_speaker_upload"+this.editing_item][0], options);
        //console.log(this.$refs["edit_speaker_upload"+this.editing_item][0]);


      // Set signed upload URL for each file
      // Set signed upload URL for each file
      vm.dropzone_editor.on('processing', (file) => {
        vm.dropzone_editor.options.url = file.uploadURL
      })


      vm.dropzone_editor.on('success', (file) => {
        //vm.dropzone.options.url = file.uploadURL

        ////console.log(file);

       //var vidObj = {video:file.name,video_status:'UPLOADED'};
       // vm.$store.commit('currentShuttleVideo', vidObj);



        vm.saveUpload(file);

      })


  }
      },






  }


}
</script>
